import kotBotPrinter from '@/api/restaurant-sale/kot-bot-printer'
import users from '@/api/security/users'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  branches: [],
  groups: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_BRANCH(state, data) {
    state.branches = data
  },
  SET_GROUP_LIST(state, data) {
    state.groups = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        filter: {
          search: context.state.search
        }
      },
      attrubutes
    )
    return kotBotPrinter.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return kotBotPrinter.store(data)
  },
  update(context, { id, data }) {
    return kotBotPrinter.update(id, data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await kotBotPrinter.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  destroy(context, data){
    return kotBotPrinter.destroy(data)
  },
  async fetchPreData(context) {
    let branch = await users.branchAssigned()
    context.commit('SET_BRANCH', branch.data)
    let group = await kotBotPrinter.group()
    context.commit('SET_GROUP_LIST', group.data)
  }
}
